<div class="recovery-page-wrap height-100">
  <div class="session-form-hold">
    <div class="text-center pt-8 pb-16">
      <img
        src="assets/images/MT18815.gif"
        alt="QTAC Choose the Future"
        class="mb-05"
      />
      <p class="heading-text">
        Please enter your email address and we'll send a password recovery
        email.
      </p>
    </div>
    <form [formGroup]="emailForm" (ngSubmit)="onSubmit()">
      <div class="recovery-input-container">
        <div>Email Address</div>
        <input
          data-test="input-email"
          class="qtac-input"
          name="email"
          type="email"
          formControlName="email"
          value=""
        />
        <small
          data-test="error-email"
          *ngIf="
            emailForm.controls['email'].hasError('required') &&
            emailForm.controls['email'].touched
          "
          class="form-error-msg error-msg"
        >
          Please provide an email.
        </small>
        <small
          data-test="error-email"
          *ngIf="
            emailForm.controls['email'].hasError('email') &&
            emailForm.controls['email'].touched
          "
          class="form-error-msg error-msg"
        >
          Please provide a valid email.
        </small>
      </div>
      <div class="text-center">
        <button
          data-test="submit-button"
          mat-raised-button
          class="recovery-button mb-1"
          [disabled]="emailForm.invalid"
        >
          SEND EMAIL
        </button>
      </div>
      <!-- <div class="text-center">
        <a
          [routerLink]="'/sessions/signin'"
          class="mat-primary text-center full-width"
          >Sign in</a
        >
        <span fxFlex></span>
        <a
          [routerLink]="'/sessions/signup'"
          class="mat-primary text-center full-width"
          >Create a new account</a
        >
      </div> -->
    </form>
  </div>
</div>
